import React from "react";

import { useForgotPassword } from "./useForgotPassword";
import { Error } from "../../_common/Error";
import { SuccessMessage } from "../../_common/SuccessMessage";

const ForgotPassword = () => {
  const {
    isLoading,
    email,
    setEmail,
    error,
    handleSubmit,
    successMessage,
  } = useForgotPassword();

  return (
    <form className="tw-space-y-6" onSubmit={handleSubmit}>
      {error && <Error message={error} />}
      {successMessage && <SuccessMessage message={successMessage} />}
      <div>
        <label htmlFor="email" className="w-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900"> Enter your e-mail address below to reset your password. </label>
        <div className="tw-mt-2">
          <input
            className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
            type="email"
            autoComplete="off"
            name="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="forgot-password-email"
          />
        </div>
      </div>

      <button
        className="tw-flex tw-w-full tw-rounded-md tw-bg-blue-500 tw-justify-center tw-px-3 tw-py-1.5 tw-text-sm tw-font-semibold tw-text-white tw-shadow-xs hover:tw-bg-blue-400 focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-blue-500"
        type="submit"
        disabled={isLoading}
      >
        {isLoading ? "Loading..." : "Request Password Reset"}
      </button>
  
    </form>
  );
};

export { ForgotPassword };
